import { render, staticRenderFns } from "./IsTemp.vue?vue&type=template&id=e20a7a72&scoped=true"
import script from "./IsTemp.vue?vue&type=script&lang=js"
export * from "./IsTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20a7a72",
  null
  
)

export default component.exports